module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lhk4k"))).then(() => parcelRequire('iDabs'));